import { DropdownToggle } from 'reactstrap';

import { ProxyDropDownToggleProps } from './types';

import './DropdownToggle.module.scss';

export const ProxyDropdownToggle = ({ testId, ...restProps }: ProxyDropDownToggleProps) => (
  <DropdownToggle data-testid={testId ?? 'dropdown-toggle'} {...restProps} />
);
